export interface CarouselAutoplayOptions {
  delay: number;
  disableOnInteraction?: boolean;
}
